import { render } from "./z-files-upload.vue?vue&type=template&id=a2a40214&scoped=true"
import script from "./z-files-upload.vue?vue&type=script&lang=js"
export * from "./z-files-upload.vue?vue&type=script&lang=js"

import "./z-files-upload.vue?vue&type=style&index=0&id=a2a40214&lang=sass&scoped=true"

import exportComponent from "/Users/matejglasnak/gitrepo/jandl-taskmanager-app/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a40214"]])

export default __exports__